import {CableModel} from './cable.model';
import {LocationModel} from './location.model';

export interface LocationConnectionModel {
    id?: string | null;
    fromLocationId?: string | null;
    toLocationId?: string | null;
    created?: Date;

    fromLocation?: LocationModel | null;
    toLocation?: LocationModel | null;
    cables?: CableModel[] | null;
    noCableCores?: CableModel[] | null; // Cores without a cable
}
